import { render, staticRenderFns } from "./SkillQualificationCategories.vue?vue&type=template&id=955ffdf0&scoped=true&"
import script from "./SkillQualificationCategories.vue?vue&type=script&lang=js&"
export * from "./SkillQualificationCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955ffdf0",
  null
  
)

export default component.exports